import BlipConstants from '../constants/blip';
import { BuilderRequest } from 'models/request/BuilderRequest';
import { ResourceRequest } from 'models/request/ResourceRequest';
import { CloneRequest } from 'models/request/CloneRequest';
import { cloneBucket, cloneEntities, cloneIntentions, cloneResource, getBucket, getEntities, getIntentions, getResources } from 'services/CeberusApiService';

export default class CloneService {
  static getPublishedFlowAsync = async (identity, clusterName) => {
    const request = new BuilderRequest(BlipConstants.BUILDER_WORKING_FLOW_BUCKET_KEY, clusterName, identity, null);
    return await getBucket(request);
  }
  
  static getConfigurationsAsync = async (identity, clusterName) => {
    const request = new BuilderRequest(BlipConstants.BUILDER_WORKING_CONFIGURATION_VARIABLES_BUCKET_KEY, clusterName, identity, null);
    return await getBucket(request);
  }
  
  static getGlobalActionsAsync = async (identity, clusterName) => {
    const request = new BuilderRequest(BlipConstants.BUILDER_WORKING_GLOBAL_ACTIONS_BUCKET_KEY, clusterName, identity, null);
    return await getBucket(request);
  }

  static getIntentions = async (identity, clusterName) => {
    const request = new CloneRequest();
    request.BotIdentifier = identity;
    request.ClusterName = clusterName;
    return await getIntentions(request)
  }

  static getEntities = async (identity, clusterName) => {
    const request = new CloneRequest();
    request.BotIdentifier = identity;
    request.ClusterName = clusterName;
    return await getEntities(request);
  }

  static getResources = async (identity, clusterName) => {
    const request = new ResourceRequest();
    request.BotIdentifier = identity;
    request.ClusterName = clusterName;
    return await getResources(request);
  }

  static cloneResourcesAsync = async ({ originIdentity, destinationIdentity, clusterName }) => {
    const request = new ResourceRequest();
    request.BotIdentifier = originIdentity;
    request.BotIdentifierDestination = destinationIdentity;
    request.ClusterName = clusterName;
    await cloneResource(request);
  }

  static cloneFlowAsync = async ({ originIdentity, destinationIdentity, clusterName }) => {
    const request = new BuilderRequest(BlipConstants.BUILDER_WORKING_FLOW_BUCKET_KEY, clusterName, originIdentity, destinationIdentity);
    await cloneBucket(request);
  }
  
  static cloneConfigurationAsync = async ({ originIdentity, destinationIdentity, clusterName }) => {
    const request = new BuilderRequest(BlipConstants.BUILDER_WORKING_CONFIGURATION_VARIABLES_BUCKET_KEY, clusterName, originIdentity, destinationIdentity);
    await cloneBucket(request);
  }
  
  static cloneGlobalActionsAsync = async ({ originIdentity, destinationIdentity, clusterName }) => {
    const request = new BuilderRequest(BlipConstants.BUILDER_WORKING_GLOBAL_ACTIONS_BUCKET_KEY, clusterName, originIdentity, destinationIdentity);
    await cloneBucket(request);
  }

  static cloneIntentionsAsync = async ({ originIdentity, destinationIdentity, clusterName }) => {
    const request = new CloneRequest();
    request.BotIdentifier = originIdentity;
    request.BotIdentifierDestination = destinationIdentity;
    request.ClusterName = clusterName;
    await cloneIntentions(request);
  }

  static cloneEntitiesAsync = async ({ originIdentity, destinationIdentity, clusterName }) => {
    const request = new CloneRequest();
    request.BotIdentifier = originIdentity;
    request.BotIdentifierDestination = destinationIdentity;
    request.ClusterName = clusterName;
    await cloneEntities(request);
  }
}